//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {
  name: 'Search',
  props: {
    initialValue: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: '',
    },
    showBack: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    searchText: '',
  }),
  methods: {
    clearText() {
      this.searchText = ''
    },
    doSearch() {
      this.$emit('on-search', this.searchText)
    },
    back() {
      window.history.back()
    },
  },
  events: {
    'clear-search': function clearSearch() {
      this.searchText = ''
    },
  },
  created() {
    this.searchText = this.initialValue
  },
}



// WEBPACK FOOTER //
// ./client/components/Common/Search.vue